import React from "react";
import useSWR from "swr";
import { Box, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import { typo } from "../../../assets/fonts/font";
import colorConfigs from "../../../configs/colorConfigs";
import { PATH_NAME } from "../../../configs/pathName";
import { generalFetcher } from "../../../helpers/Fetchers/fetchers";
import { AWS_URL } from '../../../configs/constants';

const FindUsSection: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const { data: partners, error } = useSWR(PATH_NAME.API_GET_PARTNERS, generalFetcher);

  if (error) return <Typography>Error loading partners.</Typography>;
  if (!partners) return <Typography>Loading...</Typography>;

  return (
    <Box
      sx={{
        padding: 4,
        marginBottom:8,
        textAlign: "center",
        backgroundColor: colorConfigs.mainbody,
      }}
    >
      <Typography sx={{ ...typo.sectionHeadline }} paddingBottom="20px">
        Find us everywhere
      </Typography>

      <Grid
        container
        spacing={2}
        justifyContent="center"
        wrap={isMobile ? "wrap" : "nowrap"}
        sx={{
          overflow: "hidden",
          flexWrap: isMobile ? "wrap" : "nowrap",
          width: "100%",
        }}
      >
        {partners.map((partner: { id: React.Key | null | undefined; logo: any; name: string | undefined; }) => (
          <Grid
            item
            key={partner.id}
            xs={6}
            sm
            sx={{
              flexBasis: isMobile ? "50%" : "14.28%",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Box
              component="img"
              src={`${AWS_URL}/${partner.logo}`}
              
              alt={partner.name}
              sx={{
                width: "90%",
                height: "auto",
                objectFit: "contain",
              }}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default FindUsSection;
